import { isSameDay } from "date-fns";
export const doesAnyDatePointMatchDate = (time) => (data) => {
    return data.find((d) => isSameDay(d.date, time)) !== undefined;
};
//# sourceMappingURL=doesAnyDatePointMatchDate.js.map